export default __webpack_public_path__ + "9155ffc6175bf7e43ea5bfa0b4571ef5.svg";